const paths = {
  docs: () => '/docs/',
  about: () => '/about',
  home: () => '/',
  evaluations: {
    create: () => '/evaluations/create',
    alarms: (id: string) => `/evaluations/${id}#related-alarms`,
    connections: (id: string) => `/evaluations/${id}/connections`,
    runs: (id: string) => `/evaluations/${id}/runs`,
    tasks: (id: string) => `/evaluations/${id}/tasks`,
    tests: (id: string) => `/evaluations/${id}/tests`,
    show: (id: string) => `/evaluations/${id}`,
    all: () => '/evaluations',
  },
  models: {
    all: () => '/models',
    connections: (id: string) => `/models/${id}/connections`,
    create: () => '/models/create',
    runs: (id: string) => `/models/${id}/runs`,
    show: (id: string) => `/models/${id}`,
  },
  evaluationSessions: {
    show: (id: string) => `/evaluation-sessions/${id}`,
  },
  alarms: {
    all: () => '/alarms',
    create: () => '/alarms/create',
    show: (id: string) => `/alarms/${id}`,
  },
  subscriptions: {
    all: (redirect?: string) => '/subscriptions' + (redirect ? `?redirect=${redirect}` : ''),
    success: () => '/user/profile',
    cancel: () => '/subscriptions',
  },
  tests: {
    random: () => '/evaluations/random/tests',
  },
  user: {
    alarms: () => '/user/profile#alarms',
    login: (redirect?: string) => '/user/login' + (redirect ? `?redirect=${redirect}` : ''),
    logout: () => '/user/logout',
    me: () => '/user/profile',
    profile: (id: string) => `/user/${id}`,
    register: (redirect?: string) => '/user/register' + (redirect ? `?redirect=${redirect}` : ''),
    forgotPassword: () => `/user/forgot_password`,
    resetPassword: () => `/user/reset_password`,
  },
  login: {
    github: (redirect?: string) => '/user/login/github' + (redirect ? `?redirect=${redirect}` : ''),
  },
}

export default paths
